<template>
  <div class="scrollable-table">
    <table data-qa="results-table">
      <slot />
    </table>
  </div>
</template>

<style lang="scss">
.scrollable-table {
  max-width: 390px;
  margin: 0 auto;
  overflow: hidden;
  overflow-x: scroll;

  @media screen and (min-width: 650px) {
    max-width: 100%;
    overflow: none;
    overflow-x: auto;
  }
}

table {
  background-color: #f7f7f7;
  border-collapse: separate;
  border-radius: 5px;
  border: 1px solid #d5d5d5;
  border-spacing: 0;
  font-size: 1.1em;
  margin: 25px auto 0;
  position: relative;
  min-width: 650px;

  @media screen and (min-width: 760px) {
    min-width: 760px;
  }
}

th,
td {
  border-bottom: 1px solid #e8e8e8;
  padding: 5px;
  position: relative;
  margin: 0;
}

th:first-of-type {
  border-radius: 5px 0 0 0;
}

th:last-of-type {
  border-radius: 0 5px 0 0;
}

th {
  background-color: #3a3ad3;
  border-bottom: none;
  border-left: 1px solid #66f;
  border-right: 1px solid #009;
  color: #fff;
  font-weight: normal;
}

tbody td {
  transition: background-color 0.5s;
  position: relative;
  text-align: center;
}

tr.odd td {
  background-color: #f1f1f1;
}

tr.is-visitor td {
  background-color: #dad8d8;
  color: #555;
}

tr:hover td {
  background-color: #d0dafd;
  cursor: pointer;
}

.graph:hover td {
  background-color: transparent;
}

.u-left {
  text-align: left;
}
</style>
